import { Link, useOutletContext } from "react-router-dom";
import { TaskStatusSelect } from "../../components/TaskStatusSelect";
import { workClassLabels } from "../../domain/operations";
import { tasksForEvent } from "../../domain/operationsQueries";
import { useOperations } from "../../state/OperationsProvider";

export function EventWork() {
  const { eventId } = useOutletContext<{ eventId: string }>();
  const { snapshot, setTaskStatus } = useOperations();
  const event = snapshot?.events.find((item) => item.id === eventId);
  if (!snapshot || !event) return null;
  const tasks = tasksForEvent(snapshot, event.id);

  return (
    <div className="event-work">
      <h3>Work</h3>
      <p className="muted">Task status is independent of Event status. Operations, not the Event date, decides when this work should run.</p>
      {event.status === "completed" && <p className="muted">This Event is Completed. Incomplete Tasks remain active until they are finished.</p>}
      {event.status === "cancelled" && <p className="muted">This Event is Cancelled. History is kept. Unfinished work is not active Operations.</p>}
      <div className="task-table event-task-table" role="table" aria-label={`${event.name} work`}>
        <div className="task-row table-head" role="row"><span>Work</span><span>Class</span><span>Assigned</span><span>Schedule / eligibility</span><span>Status</span></div>
        {tasks.map((task) => {
          const staff = snapshot.staff.find((item) => item.id === task.assignedTo);
          return (
            <div className={`task-row ${task.status === "blocked" ? "blocked-row" : ""}`} role="row" key={task.id}>
              <button className={`check ${task.status === "complete" ? "done" : ""}`} onClick={() => setTaskStatus(task.id, task.status === "complete" ? "scheduled" : "complete")} aria-label={`${task.status === "complete" ? "Reopen" : "Complete"} ${task.title}`}>{task.status === "complete" ? "✓" : ""}</button>
              <div className="task-name">
                <strong>{task.title}</strong>
                <small className={task.status === "blocked" ? "blocked-note" : ""}>{task.blockerNote ? `! ${task.blockerNote}` : task.activityLabel ? `${task.activityLabel} · ${task.detail}` : task.detail}</small>
              </div>
              <span className={`tag ${task.classification}`}>{workClassLabels[task.classification]}</span>
              <div className="assignee"><span className="mini-avatar">{staff?.initials}</span>{staff?.name ?? "Unassigned"}</div>
              <span>{task.scheduledTime ?? (task.status === "eligible" ? "Eligible — not forced to Event date" : "Unscheduled")}</span>
              <TaskStatusSelect task={task} onStatus={setTaskStatus} />
            </div>
          );
        })}
      </div>
      <p className="muted"><Link to="/today">Return to Today</Link></p>
    </div>
  );
}
